import { Cancel } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const FailAlert = () => {
  const { t } = useTranslation();
  return (
    <Stack direction="row" spacing="0.5rem">
      <Cancel color="error" />
      <Typography>{t('COMMON.FSP.CONNECTION_TEST.FALSE')}</Typography>
    </Stack>
  );
};
